const BOOKING_STATUS_LABELS: Record<string, string> = {
  canceled: "Canceled",
  cancelled: "Canceled",
};

export function formatBookingStatusLabel(status: unknown): string {
  const normalized = String(status ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  if (!normalized) return "Unknown";

  return (
    BOOKING_STATUS_LABELS[normalized] ??
    normalized
      .split("_")
      .filter(Boolean)
      .map((word) => word[0].toUpperCase() + word.slice(1))
      .join(" ")
  );
}
